import { mapGetters } from "vuex";
import * as numeral from "numeral";

export default {
    props: {
        isShow: {
            type: Boolean,
            required: true
        },
        selectNo: {
            type: String,
            required: true
        },
        multiSelect: {
            type: Boolean,
            default: false
        },
        condition: {
            type: String,
            default: ""
        },
        initData: {
            type: Array,
            default: () => []
        },
        quickSelectOptions: {
            type: Object,
            default: () => {}
        },
        varOptions: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            // 主表
            innerMasterSortField: null,
            innerMasterSortOrder: null,
            innerMasterPageSize: 0,
            masterPageNo: 1,
            masterTotal: 0,

            // 从表
            innerDetailSortField: null,
            innerDetailSortOrder: null
        };
    },
    computed: {
        ...mapGetters(["getSelectData"]),
        selectInfo() {
            return this.getSelectData[this.selectNo];
        },
        masterFields() {
            return this.decodeFields(this.selectInfo.master_fields);
        },
        masterSort() {
            return this.decodeSort(this.selectInfo.master_orderby);
        },
        masterSortField: {
            get() {
                return this.innerMasterSortField || this.masterSort.field;
            },
            set(newVal) {
                this.innerMasterSortField = newVal;
            }
        },
        masterSortOrder: {
            get() {
                return this.innerMasterSortOrder || this.masterSort.order;
            },
            set(newVal) {
                this.innerMasterSortOrder = newVal;
            }
        },
        masterPageSize: {
            get() {
                return this.innerMasterPageSize || this.selectInfo.master_page_size || (this.selectInfo.select_type === 2 ? 10 : 20);
            },
            set(newVal) {
                this.innerMasterPageSize = newVal;
            }
        },
        detailFields() {
            if (this.selectInfo.select_type === 2) {
                return this.decodeFields(this.selectInfo.detail_fields);
            }
            return [];
        },
        detailSort() {
            if (this.selectInfo.select_type === 2) {
                return this.decodeSort(this.selectInfo.detail_orderby);
            }
            return null;
        },
        detailSortField: {
            get() {
                if (this.detailSort) {
                    return this.innerDetailSortField || this.detailSort.field;
                }
                return null;
            },
            set(newVal) {
                if (this.detailSort) {
                    this.innerDetailSortField = newVal;
                }
            }
        },
        detailSortOrder: {
            get() {
                if (this.detailSort) {
                    return this.innerDetailSortOrder || this.detailSort.order;
                }
                return null;
            },
            set(newVal) {
                if (this.detailSort) {
                    this.innerDetailSortOrder = newVal;
                }
            }
        },
        queryFields() {
            let fields = [];
            if (this.selectInfo.master_query_fields) {
                this.selectInfo.master_query_fields.split(";").forEach((item) => {
                    let field = this.masterFields.find((element) => item.toUpperCase() === element.name);
                    if (field) {
                        fields.push({
                            table: "master",
                            name: field.name,
                            label: field.label,
                            type: field.type || "CHAR",
                            dictNo: field.dictNo
                        });
                    }
                });
            }
            if (this.selectInfo.select_type === 2 && this.selectInfo.detail_query_fields) {
                this.selectInfo.detail_query_fields.split(";").forEach((item) => {
                    let field = this.detailFields.find((element) => item.toUpperCase() === element.name);
                    if (field) {
                        fields.push({
                            table: "detail",
                            name: field.name,
                            label: field.label,
                            type: field.type || "CHAR",
                            dictNo: field.dictNo
                        });
                    }
                });
            }
            return fields;
        }
    },
    methods: {
        notEmpty(value) {
            return (value && !(value instanceof Array)) || (value instanceof Array && value.length > 0);
        },
        createQueryCondition(fields) {
            if (fields) {
                let masterCondition = "";
                let detailCondition = "";
                fields.forEach((field) => {
                    if (this.notEmpty(field.value)) {
                        let localCondition = "";
                        if (field.type === "NUMBER") {
                            if (field.value instanceof Array) {
                                if (field.value[0]) {
                                    localCondition += " AND " + field.name + ">=" + field.value[0];
                                }
                                if (field.value[1]) {
                                    localCondition += " AND " + field.name + "<=" + field.value[1];
                                }
                            } else {
                                localCondition += " AND " + field.name + "=" + field.value;
                            }
                        } else if (field.type === "DATE") {
                            if (field.value instanceof Array) {
                                if (field.value[0]) {
                                    localCondition += " AND " + field.name + ">='" + field.value[0] + "'";
                                }
                                if (field.value[1]) {
                                    localCondition += " AND " + field.name + "<='" + field.value[1] + "'";
                                }
                            } else {
                                localCondition += " AND " + field.name + "='" + field.value + "'";
                            }
                        } else if (field.dictNo) {
                            if (field.value instanceof Array) {
                                localCondition += " AND " + field.name + " IN (" + field.value.join(",") + ")";
                            } else {
                                localCondition += " AND " + field.name + "=" + field.value;
                            }
                        } else {
                            localCondition += " AND " + field.name + " LIKE '%" + field.value + "%'";
                        }

                        if (field.table === "detail") {
                            detailCondition += localCondition;
                        } else {
                            masterCondition += localCondition;
                        }
                    }
                });

                if (this.selectInfo.select_type === 2 && detailCondition) {
                    masterCondition +=
                        " AND ID IN (SELECT " +
                        this.selectInfo.detail_fk +
                        " FROM (" +
                        this.selectInfo.detail_sql +
                        " WHERE 1=1 " +
                        detailCondition +
                        ") DATASELECT_DETAIL_TABLE)";
                }
                return masterCondition;
            }
            return "";
        },
        decodeFields(str) {
            let fields = [];
            if (str) {
                str.split(";").forEach((item) => {
                    let field = {};
                    field.name = item.substring(0, item.indexOf("|")).toUpperCase();
                    field.label = item.substring(item.indexOf("|") + 1);
                    if (field.label && field.label.indexOf("[") !== -1 && field.label.indexOf("]") !== -1) {
                        let field_props = field.label.substring(field.label.indexOf("[") + 1, field.label.indexOf("]"));
                        if (field_props) {
                            let prop_arr = field_props.split("|");
                            if (prop_arr.length > 0) {
                                field.width = numeral(prop_arr[0]).value();
                            }
                            if (prop_arr.length > 1) {
                                field.type = prop_arr[1];
                            }
                            if (prop_arr.length > 2) {
                                field.format = prop_arr[2];
                            }
                            if (prop_arr.length > 3) {
                                field.dictNo = prop_arr[3];
                            }
                        }
                        field.label = field.label.substring(0, field.label.indexOf("["));
                    }
                    fields.push(field);
                });
            }
            return fields;
        },
        decodeSort(orderby) {
            let sort = { field: "ID", order: "ASC" };
            if (orderby) {
                let arr = orderby.split(/\s+/);
                sort.field = arr[0];
                sort.order = (arr[1] || "").toUpperCase() === "DESC" ? "DESC" : "ASC";
            }
            return sort;
        }
    }
};
